module.exports = __webpack_public_path__ + "img/all-active.205f5ee6.svg";